export default {
  metaTitle: 'Apply for BigPromotion',
  pageTitle: '开始提交调价',
  applied: 'The current type and specifications of Promotion applied',
  main1: 'Platform Promotions',
  placeholder1: 'Listing#',
  placeholder2: 'Sku#',
  placeholder3: 'Listing Title',
  placeholder4: 'Store Category',
  placeholder5: 'Select the Up-shelf time',
  filter: 'Filter',
  buttonName1: 'Platform category',
  buttonName2: 'Category',
  columns1: 'Select All',
  columns2: 'Listing ID',
  columns3: 'Title',
  columns4: 'Price(Min)',
  columns5: 'Price(max)',
  columns6: 'Active Aku Count'
}
